import { Button, Col, message, Modal, Row, Space } from 'antd'
import { AiKoutuIcon } from '../Icons/AiKoutuIcon'
import styles from './styles.module.scss'

import { useEffect, useMemo, useState } from 'react'
import { FileDTO, SHIBEI_FACE_BLUR } from '@/api/MaterialApi'
import AsyncButton from '../AsyncButton'
import { getOriginImageUrl } from '../AiKoutuButton'

export type AiFaceBlurButtonProps = {
  originImgUrl?: string
  imageInfo?: any
  productCode?: string
  onSaveFaceBlur?: (
    oldUrl: string,
    newUrl: string,
    options: {
      oldInfo: any
      newInfo: any
    },
  ) => Promise<void>
  type?: 'detailsPicture' | 'mainPicture'
}

export function AiFaceBlurButton(props: AiFaceBlurButtonProps) {
  const [isModelOpen, setIsModelOpen] = useState(false)
  //   const [kouTuUrl, setKouTuUrl] = useState('')
  const [koutuRes, setFaceBlurRes] = useState<FileDTO[]>([])
  const [loading, setLoading] = useState(false) // 新增loading状态
  const { originImgUrl, imageInfo, onSaveFaceBlur, productCode, type } = props

  const openModal = () => {
    setIsModelOpen(true)
  }

  const closeModal = () => {
    setIsModelOpen(false)
    setFaceBlurRes([]) // 关闭弹窗时清空抠图URL
  }

  async function getFaceBlurUrl() {
    if (!originImgUrl) return
    setLoading(true)
    try {
      //  参考文档: https://docs.zcbot.cn/pages/seabase/open/koutu/#%E6%8E%A5%E5%8F%A3%E8%AF%B7%E6%B1%82
      //   const apiUrl = `https://open-api.zcbot.cn/koutu-api/koutu/url?url=${encodeURIComponent(
      //     originImgUrl,
      //   )}`
      const res = await SHIBEI_FACE_BLUR({
        url: originImgUrl,
        productCode: productCode,
        type: type,
      })

      if (res.code === 0) {
        setFaceBlurRes([res.data])
      } else {
        // 可以添加错误处理，例如使用 antd 的 message 组件提示用户
        console.error('处理失败:', res.msg)
        message.error(res.msg || '处理失败')
      }
    } catch (error) {
      console.error('请求人脸模糊接口失败:', error)
      // message.error('请求人脸模糊接口失败');
    } finally {
      setLoading(false)
    }
  }

  async function handleSaveFaceBlur() {
    const newInfo = koutuRes?.[0]
    const newUrl = getOriginImageUrl(newInfo)

    await onSaveFaceBlur?.(originImgUrl ?? '', newUrl, {
      oldInfo: imageInfo,
      newInfo,
    })
    closeModal()
  }
  useEffect(() => {
    if (isModelOpen && originImgUrl) {
      getFaceBlurUrl()
    }
  }, [isModelOpen, originImgUrl])

  return (
    <>
      <Space onClick={openModal} className={styles.container}>
        <AiKoutuIcon />
        <span>人脸模糊</span>
      </Space>
      <Modal
        title={'人脸模糊'}
        onCancel={closeModal}
        footer={
          <Row justify={'center'}>
            <Space>
              <Button onClick={closeModal}>取消</Button>
              <AsyncButton type="primary" onClick={handleSaveFaceBlur}>
                保存处理结果
              </AsyncButton>
            </Space>
          </Row>
        }
        open={isModelOpen}
        width={800} // 适当调整弹窗宽度
      >
        <Row gutter={16}>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>原图</h3>
            {originImgUrl ? (
              <img
                src={originImgUrl + '?v=' + Date.now()}
                alt="原图"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            ) : (
              <p>暂无原图</p>
            )}
          </Col>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>处理结果</h3>
            {loading && <p>处理中，请稍候...</p>}
            {!loading && koutuRes && (
              <img
                src={
                  koutuRes?.[0]?.baseUrl +
                  koutuRes?.[0]?.url +
                  '?v=' +
                  Date.now()
                }
                alt="处理"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            )}
            {!loading && !koutuRes && originImgUrl && <p>处理失败或未开始</p>}
            {!originImgUrl && <p>请先提供原图</p>}
          </Col>
        </Row>
      </Modal>
    </>
  )
}
import { Button, Col, message, Modal, Row, Space } from 'antd'
import { AiKoutuIcon } from '../Icons/AiKoutuIcon'
import styles from './styles.module.scss'

import { useEffect, useMemo, useState } from 'react'
import { FileDTO, SHIBEI_FACE_BLUR } from '@/api/MaterialApi'
import AsyncButton from '../AsyncButton'
import { getOriginImageUrl } from '../AiKoutuButton'

export type AiFaceBlurButtonProps = {
  originImgUrl?: string
  imageInfo?: any
  productCode?: string
  onSaveFaceBlur?: (
    oldUrl: string,
    newUrl: string,
    options: {
      oldInfo: any
      newInfo: any
    },
  ) => Promise<void>
  type?: 'detailsPicture' | 'mainPicture'
}

export function AiFaceBlurButton(props: AiFaceBlurButtonProps) {
  const [isModelOpen, setIsModelOpen] = useState(false)
  //   const [kouTuUrl, setKouTuUrl] = useState('')
  const [koutuRes, setFaceBlurRes] = useState<FileDTO[]>([])
  const [loading, setLoading] = useState(false) // 新增loading状态
  const { originImgUrl, imageInfo, onSaveFaceBlur, productCode, type } = props

  const openModal = () => {
    setIsModelOpen(true)
  }

  const closeModal = () => {
    setIsModelOpen(false)
    setFaceBlurRes([]) // 关闭弹窗时清空抠图URL
  }

  async function getFaceBlurUrl() {
    if (!originImgUrl) return
    setLoading(true)
    try {
      //  参考文档: https://docs.zcbot.cn/pages/seabase/open/koutu/#%E6%8E%A5%E5%8F%A3%E8%AF%B7%E6%B1%82
      //   const apiUrl = `https://open-api.zcbot.cn/koutu-api/koutu/url?url=${encodeURIComponent(
      //     originImgUrl,
      //   )}`
      const res = await SHIBEI_FACE_BLUR({
        url: originImgUrl,
        productCode: productCode,
        type: type,
      })

      if (res.code === 0) {
        setFaceBlurRes([res.data])
      } else {
        // 可以添加错误处理，例如使用 antd 的 message 组件提示用户
        console.error('处理失败:', res.msg)
        message.error(res.msg || '处理失败')
      }
    } catch (error) {
      console.error('请求人脸模糊接口失败:', error)
      // message.error('请求人脸模糊接口失败');
    } finally {
      setLoading(false)
    }
  }

  async function handleSaveFaceBlur() {
    const newInfo = koutuRes?.[0]
    const newUrl = getOriginImageUrl(newInfo)

    await onSaveFaceBlur?.(originImgUrl ?? '', newUrl, {
      oldInfo: imageInfo,
      newInfo,
    })
    closeModal()
  }
  useEffect(() => {
    if (isModelOpen && originImgUrl) {
      getFaceBlurUrl()
    }
  }, [isModelOpen, originImgUrl])

  return (
    <>
      <Space onClick={openModal} className={styles.container}>
        <AiKoutuIcon />
        <span>人脸模糊</span>
      </Space>
      <Modal
        title={'人脸模糊'}
        onCancel={closeModal}
        footer={
          <Row justify={'center'}>
            <Space>
              <Button onClick={closeModal}>取消</Button>
              <AsyncButton type="primary" onClick={handleSaveFaceBlur}>
                保存处理结果
              </AsyncButton>
            </Space>
          </Row>
        }
        open={isModelOpen}
        width={800} // 适当调整弹窗宽度
      >
        <Row gutter={16}>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>原图</h3>
            {originImgUrl ? (
              <img
                src={originImgUrl + '?v=' + Date.now()}
                alt="原图"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            ) : (
              <p>暂无原图</p>
            )}
          </Col>
          <Col span={12} style={{ textAlign: 'center' }}>
            <h3>处理结果</h3>
            {loading && <p>处理中，请稍候...</p>}
            {!loading && koutuRes && (
              <img
                src={
                  koutuRes?.[0]?.baseUrl +
                  koutuRes?.[0]?.url +
                  '?v=' +
                  Date.now()
                }
                alt="处理"
                style={{ maxWidth: '100%', maxHeight: '400px' }}
              />
            )}
            {!loading && !koutuRes && originImgUrl && <p>处理失败或未开始</p>}
            {!originImgUrl && <p>请先提供原图</p>}
          </Col>
        </Row>
      </Modal>
    </>
  )
}
